import { createContext, useContext } from 'react';

export type VariableContentChannel = {
  id: string;
  name: string;
};

export type VariableContentHostConfig = {
  channels: VariableContentChannel[];
  selectedChannelId?: string;
};

export const VariableContentChannelsContext = createContext<VariableContentHostConfig>({
  channels: [],
});

export function useVariableContentChannels(): VariableContentHostConfig {
  return useContext(VariableContentChannelsContext);
}

export function resolveChannelLabel(channels: VariableContentChannel[], value: string): string {
  if (value === 'default') {
    return 'Default';
  }

  const match = channels.find((channel) => channel.id === value);

  return match?.name ?? 'Unknown channel';
}
